import styled from 'styled-components';

export const BoxRecorded = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BoxWrapper = styled.div`
  width: 320px;
  border: 2px solid #b8b8b8;
  padding: 16px;
  border-color: #9badc1;
  background-color: #eaf1fb;
`;

export const BoxTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 12px;
`;

export const BoxStatus = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const ProgressBar = styled.div`
  margin: 1rem 0;
`;

export const BtnAction = styled.div`
  display: flex;
  justify-content: space-between;
`;
